import geolocator from './core/geolocator';
// export default geolocator;
// http://stackoverflow.com/a/33683495/112731
module.exports = geolocator;



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/